import React from 'react'
import { InElementSlot } from 'uiComponents/navigation/sectionTabsSlot'

export const ENGAGE_TOOLS_TABLE_HEADER_SLOT_ID = 'engage-tools-table-header'

interface InEngageToolsTableHeaderProps {
    children: React.ReactNode
}

export function InEngageToolsTableHeader({ children }: InEngageToolsTableHeaderProps) {
    return <InElementSlot slotId={ENGAGE_TOOLS_TABLE_HEADER_SLOT_ID}>{children}</InElementSlot>
}

export default InEngageToolsTableHeader
